import BaseDrawer from '@/components/BaseDrawer';
import BaseDialog from "@/components/BaseDialog";

// 编辑传化出价
export function conversionDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./conversionDrawer'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '转化出价',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}
// 定向包
export function targetedPackageDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./targetedPackageDrawer/index.vue'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '定向包',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}

export function materialDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./materialDrawer/index.vue'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '素材管理',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}


// 编辑传化出价
export function honorConversionDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./honorConversionDrawer'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '转化出价',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}
// 定向包
export function honorTargetedPackageDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./honorTargetedPackageDrawer'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '定向包',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}

export function honorMaterialDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./honorMaterialDrawer'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '素材管理',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}


// 提示
export function tipModal({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./tipModal'),
    options: {
      width: '500px',
      title: '提示',
      'lock-scroll': false
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.add('f-hide');
      }
    }
  })
}